import React from "react";
import { Helmet } from "react-helmet";
import Config from "../../../Common/constants/EnvironmentConstants";

import Landing from "../../components/Landing/Landing";
import Navbar from "../../components/Navbar/Navbar";
import Youtoocan from "../../components/Youtoocan/Youtoocan";
import Steps from "../../components/Steps/Steps";
import CompaniesHired from "../../components/CompaniesHired/CompaniesHired";
import WhyIntensive from "../../components/WhyIntensive/WhyIntensive";
import Awards from "../../components/Awards/Awards";
import Brands from "../../components/Brands/Brands";
import Footer from "../../components/Footer/Footer";
import RenderScripts from "../../components/RenderScripts/RenderScripts";

export default function IntensiveEnglishRoute() {
  const urlForSeo = Config.DOMAIN_ORIGIN + "intensive-english";
  return (
    <>
      <Helmet>
        <title>
          Intensive | A Proven Program To Get You a Software Developer
        </title>
        <meta
          name="description"
          content="Intensive offers multiple job tracks such as Java and MERN Full Stack, Data Analytics, and QA/Automation Testing. Start your IT career in a powerful way."
        />
        <link rel="canonical" href={urlForSeo} />
        <meta
          property="og:title"
          content="Intensive | A Proven Program To Get You a Software Developer"
        />
        <meta
          property="og:description"
          content="Intensive offers multiple job tracks such as Java and MERN Full Stack, Data Analytics, and QA/Automation Testing. Start your IT career in a powerful way."
        />
        <meta property="og:url" content={urlForSeo} />
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:image"
          content="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/intensive-og.png"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Intensive | A Proven Program To Get You a Software Developer"
        />
        <meta
          name="twitter:description"
          content="Intensive offers multiple job tracks such as Java and MERN Full Stack, Data Analytics, and QA/Automation Testing. Start your IT career in a powerful way."
        />
        <meta
          name="twitter:image"
          content="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/intensive-og.png"
        />
        <meta name="twitter:url" content={urlForSeo} />
      </Helmet>
      <Navbar />
      <Landing />
      <Youtoocan />
      <CompaniesHired />
      <WhyIntensive />
      <Steps />
      <Awards />
      <Brands />
      <Footer />
      <RenderScripts />
    </>
  );
}
